import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useMemo, FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonStandard } from 'record-it-components/button/ButtonStandard/ButtonStandard';
import { useModalOpened } from 'record-it-components/hooks/useModalOpened/useModalOpened';
import { IconDeprecated, IconType } from 'record-it-components/misc/IconDeprecated/IconDeprecated';
import { CreateEntityButtonConfig, HeaderConfig, ManageEntitiesContentLayout } from 'record-it-components/pageContentLayout/ManageEntitiesContentLayout/ManageEntitiesContentLayout';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { EntityName } from 'record-it-time-common/EntityName';
import { WorkTimeEntry } from '../../../classes/entities/WorkTimeEntry/workTimeEntryTypes';
import { iconConfigurations } from '../../../classes/icon/iconConfigurations';
import { useEntities } from '../../../hooks/entity/useEntities/useEntities';
import { useConfigureBreadcrumbsWithBuilder } from '../../../hooks/misc/useConfigureBreadcrumbsWithBuilder';
import { useCurrentUser } from '../../../hooks/useCurrentUser';
import { ExportOwnWorkTimeDialog } from '../../workTime/ExportOwnWorkTimeDialog/ExportOwnWorkTimeDialog';
import { WorkTimeEntryList } from '../../workTime/WorkTimeEntryList/WorkTimeEntryList';
export type MyWorkTimeOverviewPageProps = PropsWithoutChildren<Record<never, never>>;
export const MyWorkTimeOverviewPage: FunctionComponent<MyWorkTimeOverviewPageProps> = React.memo(props => {
  const $ = _c(22);
  prepareProps({
    props,
    ignoreChildren: true
  });
  useConfigureBreadcrumbsWithBuilder(_temp);
  const {
    t
  } = useTranslation();
  const {
    getRequiredCurrentUser
  } = useCurrentUser();
  let t0;
  if ($[0] !== getRequiredCurrentUser) {
    t0 = getRequiredCurrentUser();
    $[0] = getRequiredCurrentUser;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const workTimeEntries = useEntities(EntityName.WorkTimeEntry, "getByUserId", t0.id);
  let t1;
  if ($[2] !== workTimeEntries) {
    t1 = workTimeEntries.sort(_temp2);
    $[2] = workTimeEntries;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const sortedWorkTimeEntries = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      closeOnBackDropClick: true
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    close: closeExportModal,
    open: openExportModal,
    modalProps: exportModalProps
  } = useModalOpened(t2);
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      visible: false
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const createEntityButtonConfig = t3;
  let t4;
  if ($[6] !== t) {
    t4 = t("components.page.MyWorkTimeOverviewPage.pageTitle");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== openExportModal) {
    t5 = () => [<ButtonStandard key="MyWorkTimeOverviewPage.ExportOwnWorkTimeButton" onClick={openExportModal} data-testid="MyWorkTimeOverviewPage.ExportOwnWorkTimeButton"><IconDeprecated type={IconType.Regular} name="file-export" /></ButtonStandard>];
    $[8] = openExportModal;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = {
      iconConfig: iconConfigurations.prefixed.page.MyWorkTimeOverviewPage.titleIcon,
      title: t4,
      renderAdditionalRightContent: t5
    };
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const headerConfig = t6;
  const renderEntities = _temp3;
  let t7;
  if ($[13] !== headerConfig || $[14] !== sortedWorkTimeEntries) {
    t7 = <ManageEntitiesContentLayout headerConfig={headerConfig} createEntityButtonConfig={createEntityButtonConfig} entities={sortedWorkTimeEntries} renderEntities={renderEntities} />;
    $[13] = headerConfig;
    $[14] = sortedWorkTimeEntries;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== closeExportModal || $[17] !== exportModalProps) {
    t8 = <ExportOwnWorkTimeDialog {...exportModalProps} onCancelClick={closeExportModal} data-testid="MyWorkTimeOverviewPage.ExportOwnWorkTimeDialog" />;
    $[16] = closeExportModal;
    $[17] = exportModalProps;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t7 || $[20] !== t8) {
    t9 = <>{t7}{t8}</>;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
});
function _temp(builder) {
  return builder.addHomePage().addMyWorkTimeOverviewPage();
}
function _temp2(a, b) {
  return b.endDate.localeCompare(a.endDate);
}
function _temp3(currentPageWorkTimeEntries) {
  return <WorkTimeEntryList workTimeEntries={currentPageWorkTimeEntries} data-testid="MyWorkTimeOverviewPage.WorkTimeEntryList" />;
}